module.exports = __webpack_public_path__ + "img/first-2.4fb1e7c0.webp";